import { SuperTokensConfig } from "supertokens-auth-react/lib/build/types";
import {
  getSuperTokensConfig,
  PreBuiltUIList as STPreBuiltUIList,
} from "./frontend";

export const frontendConfig = (): SuperTokensConfig => {
  return getSuperTokensConfig();
};

export const recipeDetails = {
  docsLink: "https://supertokens.com/docs/thirdpartypasswordless/introduction",
};

export const PreBuiltUIList = STPreBuiltUIList;
